
















import {Component, Prop, Vue} from 'vue-property-decorator';
import CustomSelectTh from '@/common/CustomSelectTh.vue';
import {Locale} from '@/services/LocaleDeserializer';
import {ConfigService} from '@/services/ConfigService';
import SelectItem from '@/common/SelectItem';
import MatomoEvents from '@/matomo/events/MatomoEvents';

export const LOCALE_COOKIE_NAME = 'eg-user-locale';

@Component({
  components: {CustomSelectTh}
})
export default class LanguageSelector extends Vue {
  @Prop({default: ''})
  public localSupportedLocales: string;

  get locales(): Locale[] {
    return ConfigService.parseLocales(this.localSupportedLocales);
  }

  get initialIndex(): string {
    const supportedLocales: Locale[] = this.locales;
    let index = 0;
    supportedLocales.forEach((currLocale, i) => {
      if (currLocale.languageCode === ConfigService.getCurrentLocale()) {
        index = i;
      }
    });
    return index.toString();
  }

  get localeSelectItems(): string {
    const localeSelectItem: string[] = this.locales.map((currLocale: Locale) => {
      return currLocale.locale.concat('::', this.$tc(currLocale.languageCode), '::');
    });
    return localeSelectItem.join(';;');
  }

  public setLocaleInCookie(locale: string) {
    MatomoEvents.forLanguage.change.publish();
    Vue.prototype.$cookie.set(LOCALE_COOKIE_NAME, locale, 30);
  }

  public getImageFilepath(current: SelectItem): string {
    return '/img/country_flags/' + current.key + '.svg';
  }

}
